<template>
  <!-- 组织机构  -->
  <div class="second-page-wrapper">
    <div class="second-page-wrapper-left">
      <news-slide :slideList="titleList"></news-slide>
    </div>
    <div class="second-page-wrapper-right">
      <router-view></router-view>
    </div>
  </div>
</template>
<style scoped>
.second-page-wrapper {
  width: 1230px;
  margin: 0 auto 30px;
  display: flex;
}
.second-page-wrapper-left {
  width: 310px;
  margin-right: 30px;
}
.second-page-wrapper-right {
  width: 890px;
}
</style>

<script>
import newsSlide from "./slide.vue";
export default {
  data() {
    return {
      titleList: [
        {
          title: "推荐新闻",
          newsFlag: "1"
        },
        {
          title: "部内要闻",
          newsFlag: "2"
        },
        {
          title: "中心动态",
          newsFlag: "3"
        }
        //  {
        //   title: "活动新闻",
        //   newsFlag: "4"
        // },
        // {
        //   title: "30周年系列活动",
        //   newsFlag: "5"
        // },
      ]
    };
  },
  components: {
    newsSlide
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/News/index.vue